import Vue from 'vue'
import Gapi from './vue-gapi'
import App from './App.vue'
import router from './router'
import Updater from './lib/api-updater'
import IdMap from './lib/id-map'
import { JsTask, newGTask, equivGTasks } from './lib/task'

Vue.config.productionTip = false

// const _tokenEndpointPrefix = 'http://localhost:5001/tasks-plus-e8b5e/us-central1'
const _tokenEndpointPrefix = 'https://tasksplus.benbreslauer.com'

const config = {
  apiKey: 'AIzaSyCGonvMaF1o_Tpql_20VES0piyatEi2rr4',
  clientId: '177166160218-s96uaptv9sqvp5li3n43ct1mf3489m4g.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/tasks',
  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/tasks/v1/rest'],
  accessTokenEndpoint: _tokenEndpointPrefix + '/accessToken',
  refreshTokenEndpoint: _tokenEndpointPrefix + '/refreshToken'
}
Vue.use(Gapi, config)

Object.defineProperty(Vue.prototype, '$Updater', { value: Updater })
Object.defineProperty(Vue.prototype, '$IdMap', { value: IdMap })
Object.defineProperty(Vue.prototype, '$JsTask', { value: JsTask })
Object.defineProperty(Vue.prototype, '$newGTask', { value: newGTask })
Object.defineProperty(Vue.prototype, '$equivGTasks', { value: equivGTasks })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
